var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaiTru(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM4.54523 4.54523C4.92431 4.16614 5.53684 4.16614 5.91593 4.54523L9 7.6293L12.0841 4.54523C12.4632 4.16614 13.0757 4.16614 13.4548 4.54523C13.8339 4.92431 13.8339 5.53684 13.4548 5.91593L10.3707 9L13.4548 12.0841C13.8339 12.4632 13.8339 13.0757 13.4548 13.4548C13.0757 13.8339 12.4632 13.8339 12.0841 13.4548L9 10.3707L5.91593 13.4548C5.53684 13.8339 4.92431 13.8339 4.54523 13.4548C4.16614 13.0757 4.16614 12.4632 4.54523 12.0841L7.6293 9L4.54523 5.91593C4.16614 5.53684 4.16614 4.92431 4.54523 4.54523Z",
    fill: "#FB7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaiTru);
export default __webpack_public_path__ + "static/media/loai-tru.74f6fd580cfcfe80d23f57834a0d3755.svg";
export { ForwardRef as ReactComponent };